import { render, staticRenderFns } from "./RevenueInfo.vue?vue&type=template&id=55a1e73b&scoped=true&"
import script from "./RevenueInfo.vue?vue&type=script&lang=js&"
export * from "./RevenueInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1e73b",
  null
  
)

export default component.exports